import { useParams } from '@gogame/screens';
import { useScreenMessage } from '@gogame/screens';

import { createNodesMarketingPlan } from 'scenes/MarketingPlanning/MarketingPlanningWizard/sources/plan';

export const useCreateNodesMarketingPlan = process => {
  const { showErrorMessage } = useScreenMessage();
  const { year, month } = useParams();
  return ({ parentId, depth, entityIds, levelPath, node, typeRequest }) => {
    return process(
      createNodesMarketingPlan({
        year,
        month,
        parentId,
        depth,
        entityIds,
        levelPath,
        node, // TODO: remove after implement inheritance on server
        typeRequest, // TODO: remove after implement inheritance on server
      })
    ).catch(e => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
  };
};
